<template>
  <router-link
    v-bind="$attrs"
    class="tw-inline-block tw-no-underline tw-text-inherit"
    :class="{'tw-transition-colors tw-duration-200 tw-ease-in-out': type === 'text'}"
  >
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text',
      validator: function (value) {
        return ['text', 'other'].indexOf(value) !== -1
      }
    }
  }
}
</script>
